<section class="mock-calendar">
  <h2 class="mtc-title">GCSE Test Calendar</h2>

  <div class="toolbar container-fluid">
    <div class="toolbar-row container">

      <!-- Category -->
      <div class="toolbar-item">
        <label>Test Category</label>
        <select class="form-select" [(ngModel)]="filters.categoryId" (change)="applyFilters()">
          <option [ngValue]="null">All</option>
          <option *ngFor="let cat of categories" [value]="cat">{{ cat }}</option>
        </select>
      </div>

      <!-- Pattern -->
      <div class="toolbar-item">
        <label>Test Pattern</label>
        <select class="form-select" [(ngModel)]="filters.pattern" (change)="applyFilters()">
          <option [ngValue]="null">All</option>
          <option *ngFor="let p of patterns" [value]="p">{{ p }}</option>
        </select>
      </div>

      <!-- Mode -->
      <div class="toolbar-item">
        <label>Test Mode</label>
        <select class="form-select" [(ngModel)]="filters.mode" (change)="applyFilters()">
          <option [ngValue]="null">Both</option>
          <option value="Online Session">Online</option>
          <option value="Classroom Session">Face to Face</option>
        </select>
      </div>

      <!-- Months -->
      <div class="toolbar-item">
        <label>Months</label>
        <select class="form-select" [(ngModel)]="filters.month" (change)="applyFilters()">
          <option [ngValue]="null">Any</option>
          <option *ngFor="let m of months" [ngValue]="m.value">{{ m.label }}</option>
        </select>
      </div>

      <!-- Centers -->
      <div class="toolbar-item">
        <label>Center</label>
        <select class="form-select" [(ngModel)]="filters.center" (change)="applyFilters()">
          <option [ngValue]="null">Any</option>
          <option *ngFor="let c of centers" [value]="c">{{ c }}</option>
        </select>
      </div>
    </div>

    <div class="text-center mt-2">
      <button class="btn btn-secondary" (click)="resetFilters()">RESET ALL FILTERS</button>
    </div>
  </div>

  <!-- List -->
  <div class="container list-body">
    <div *ngIf="testList.length; else nothingFound">
      <div class="session-card" *ngFor="let t of testList">
        <div class="date-chip">
          <span>{{ t.test_date }}</span>
        </div>
        <div class="content">
          <div class="meta">
            <a class="title">{{ trimChar(t.test_name, 60) }}</a>
            <div>{{ t.category }}</div>
            <div>{{ t.location || t.all_location }}</div>
          </div>
          <div class="grid">
            <div class="cell price">{{ t.payment_method === 'Free' ? 'Free' : '£' + t.test_fees }}</div>
            <div class="cell action"><a class="btn btn-book">Book</a></div>
          </div>
        </div>
      </div>
    </div>
    <ng-template #nothingFound>
      <div class="text-center py-5">No GCSE Test Found</div>
    </ng-template>
  </div>
  
</section>
